import { createSlice } from "@reduxjs/toolkit";
import { verifyEmailAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const verifyEmailSlice = createSlice({
  name: "verifyEmail",
  initialState: data,
  reducers: {
    verifyEmailSlice(state) {
      state.isLoading = true;
    },
    verifyEmailSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    verifyEmailSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    verifyEmailSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const verifyEmailHandler = (token:string) => async (dispatch: any) => {
  try {
    dispatch(verifyEmailAction.verifyEmailSlice());
    const response: any = await verifyEmailAPI(token);
    dispatch(verifyEmailAction.verifyEmailSliceSuccess(response));
    typeof localStorage !=="undefined"&&localStorage.setItem("username",response?.results?.screen_name);
    typeof localStorage !=="undefined"&&localStorage.setItem('userId', response?.results?.id);
    typeof localStorage !=="undefined"&&localStorage.setItem('role', response?.results?.type);
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(verifyEmailAction.verifyEmailSliceFailure(e?.response?.data?.message));
    dispatch(verifyEmailAction.verifyEmailSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export default verifyEmailSlice.reducer;
export const verifyEmailAction = verifyEmailSlice.actions;
